import * as actionTypes from "../ActionTypes";

const INITIAL = {
  userInfo: {},
  accessToken: null,
  users: [],
  loading: false,
  requests: [],          
  success: false,
  error: null,
  myCircle: [], 
  churchUsers: [], // ✅ Add this line
  notifications: [], // ✅ Add this line
  sendNotificationLoading: false, // Add this
  sendNotificationSuccess: false, // Add this
  sendNotificationError: null,


};

const UsersReducer = (state = INITIAL, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_USER_PROFILE_INFO:
      return { ...state, userInfo: action.payload };
    case actionTypes.SET_ACCESS_TOKEN:
      return { ...state, accessToken: action.payload };
      case actionTypes.AVAILABLE_USERS_REQUEST:
        return { ...state, loading: true, error: null };
        case actionTypes.SAVE_USER_CIRCLE_REQUEST:
          return { ...state, loading: true, error: null, success: false };
          case actionTypes.MY_CIRCLE_REQUESTS_REQUEST:
    return { ...state, loading: true, error: null };
    case actionTypes.UPDATE_USER_CIRCLE_REQUEST:
    return { ...state, loading: true, error: null };
    case actionTypes.MY_CIRCLE_LIST_REQUEST:
    return { ...state, loading: true, error: null };
  
      case actionTypes.AVAILABLE_USERS_SUCCESS:
        return {
          ...state,
          loading: false,
          users: action.payload?.data?.[0]?.matchingUsers || [],
        };
  
      case actionTypes.SAVE_USER_CIRCLE_SUCCESS:
          return { ...state, loading: false, success: true };
  
  case actionTypes.MY_CIRCLE_REQUESTS_SUCCESS:
      return {
        ...state,
        loading: false,
        requests: action.payload?.data || [],
      };
      case actionTypes.UPDATE_USER_CIRCLE_SUCCESS:
    return { ...state, loading: false, success: true };
  
    case actionTypes.MY_CIRCLE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        myCircle: action.payload?.data || [],
      };
  
      case actionTypes.AVAILABLE_USERS_FAIL:
        return { ...state, loading: false, error: action.payload };
        case actionTypes.SAVE_USER_CIRCLE_FAIL:
          return { ...state, loading: false, error: action.payload, success: false };
          case actionTypes.MY_CIRCLE_REQUESTS_FAIL:
    return { ...state, loading: false, error: action.payload };
  
  case actionTypes.UPDATE_USER_CIRCLE_FAIL:
      return { ...state, loading: false, error: action.payload, success: false };
      case actionTypes.MY_CIRCLE_LIST_FAIL:
          return { ...state, loading: false, error: action.payload };
          case actionTypes.GET_CHURCH_USERS_REQUEST:
      return { ...state, loading: true, error: null };
    
    case actionTypes.GET_CHURCH_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        churchUsers: action.payload?.data || [], // Store church users data
      };
    
    case actionTypes.GET_CHURCH_USERS_FAIL:
      return { ...state, loading: false, error: action.payload };
      case actionTypes.GET_NOTIFICATIONS_REQUEST:
        return { ...state, loading: true, error: null };
      
      case actionTypes.GET_NOTIFICATIONS_SUCCESS:
        return {
          ...state,
          loading: false,
          notifications: action.payload?.data || [], // Store notifications data
        };
      
      case actionTypes.GET_NOTIFICATIONS_FAIL:
        return { ...state, loading: false, error: action.payload };
        case actionTypes.SEND_NOTIFICATION_TO_ONE_REQUEST:
    return {
      ...state,
      sendNotificationLoading: true,
      sendNotificationSuccess: false,
      sendNotificationError: null,
    };
    
  case actionTypes.SEND_NOTIFICATION_TO_ONE_SUCCESS:
    return {
      ...state,
      sendNotificationLoading: false,
      sendNotificationSuccess: true,
      sendNotificationError: null,
    };
    
  case actionTypes.SEND_NOTIFICATION_TO_ONE_FAIL:
    return {
      ...state,
      sendNotificationLoading: false,
      sendNotificationSuccess: false,
      sendNotificationError: action.payload,
    };
    
    default:
      return state;
  }
};

export default UsersReducer;
